import triggerTracking from '@blueprint/tracking';

export const trackFilterClick = () => {
    triggerTracking({
        event: 'GAEvent',
        eventCategory: 'search_filters',
        eventAction: 'click',
        eventLabel: 'filter_select'
    });
};
